export default {
  trackingID: process.env.TRACKING_ID,
  clientID: process.env.CLIENT_ID,
  clientSecret: process.env.CLIENT_SECRET,
  apiDomain: process.env.API_DOMAIN,
  recaptchaKey: process.env.RECAPTCHA_KEY,
  nodeEnv: process.env.NODE_ENV
}



// WEBPACK FOOTER //
// ./src/config/index.js